import { useState } from "react";
import { LayoutGrid, List } from "lucide-react";

export const useViewMode = (key) => {
  const storageKey = `view-mode-${key}`;
  const [mode, setMode] = useState(() => localStorage.getItem(storageKey) || "list");
  const update = (m) => {
    localStorage.setItem(storageKey, m);
    setMode(m);
  };
  return [mode, update];
};

export const ViewToggle = ({ mode, onChange }) => (
  <div className="inline-flex rounded-lg border border-slate-200 bg-white p-0.5" role="group" aria-label="Görünüm">
    {[["list", List, "Satır"], ["grid", LayoutGrid, "Kutu"]].map(([m, Icon, label]) => (
      <button
        key={m}
        type="button"
        data-testid={`view-toggle-${m}`}
        onClick={() => onChange(m)}
        title={`${label} görünümü`}
        className={`flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-xs font-medium transition-colors ${mode === m ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100"}`}
      >
        <Icon className="w-3.5 h-3.5" />{label}
      </button>
    ))}
  </div>
);
